import { type CommunityMetadataBase } from '@/api/workflowCommunityPublishing.api';

export const PENDING_PUBLISHING_STATUSES = new Set([
  'pending_public',
  'pending_user_visual_compliance',
  'pending_3p_m10n_check',
  'org_private_pending_public',
]);

export const isLiveAndVerified = (metadata: CommunityMetadataBase | null | undefined): boolean =>
  metadata?.publishing_status === 'approved_public' && !metadata.unpublished_at && metadata.content_verified_at != null;

export const isPendingReview = <T extends CommunityMetadataBase>(metadata: T | null | undefined): metadata is T =>
  metadata != null &&
  !isLiveAndVerified(metadata) &&
  ((metadata.publishing_status === 'approved_public' && !metadata.unpublished_at) ||
    PENDING_PUBLISHING_STATUSES.has(metadata.publishing_status));

/**
 * The resource has a Community listing: live, or still under review. False once it is unpublished or
 * blocked — a blocked resource keeps `unpublished_at` null, so presence of metadata alone is not enough.
 *
 * Deliberately an allowlist, and built from the same two predicates `deriveCommunityPublishBannerType`
 * reads, so the share row and the status banner cannot disagree about what "published" means. The
 * `unpublished_at` check is not redundant with them: unpublishing leaves a pending status pending.
 */
export const isPublishedToCommunity = (metadata: CommunityMetadataBase | null | undefined): boolean =>
  metadata != null && !metadata.unpublished_at && (isLiveAndVerified(metadata) || isPendingReview(metadata));
